import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AskVendorComponent } from '@app/shared/components/ask-vendor/ask-vendor.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CustomHttpUrlEncodingCodec, TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { ModalCompanyInformationComponent } from '../modal-company-information/modal-company-information.component';
import { Title } from '@angular/platform-browser';
import { ChatService } from '@app/_services/chat.service';
import { ChatModalComponent } from '@app/_components/live-chat/chat-modal/chat-modal.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { EventCollectorDirective } from '../../_directives/events-collector/events.collector';

@Component({
    selector: 'app-block-company-information',
    templateUrl: './block-company-information.component.html',
    styleUrls: ['./block-company-information.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [EventCollectorDirective, MatIconModule, NgIf, TranslateModule]
})
export class BlockCompanyInformationComponent implements OnInit {

    @Input() companyData;
    @Input() fromLayout = false;
    userDetails = false;
    vendorModalRef: BsModalRef;
    bsModalRef: BsModalRef;
    image = 'assets/images/nologo.png';
    whatsapp;

    constructor(
        private modalService: BsModalService,
        private authService: AuthenticationService,
        // public bsModalRef: BsModalRef,
        private router : Router,
        private renderer: Renderer2,
        private chatService: ChatService,
        private titleService: Title,
        private deviceDetector: DeviceDetectorService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) {
        this.modalService.onHide.subscribe(() => {
            this.renderer.removeClass(document.body, 'chat-modal');
        });

        this.modalService.onShown.subscribe(() => {
            if (document.getElementsByClassName('live-chat-popup')[0]) {
                this.renderer.addClass(document.getElementsByClassName('live-chat-popup')[0].parentElement, 'live-chat');
            }

            if (this.deviceDetector.isMobile()) {
                this.renderer.addClass(document.getElementsByClassName('modal')[0], 'mobile');
            }
        });
    }

    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
    }

    ngOnChanges(): void {
        if (this.companyData.contact?.whatsapp?.e164Number) {
            // let codec = new CustomHttpUrlEncodingCodec;
            this.whatsapp = {
                // url: environment.web + this.router.url,
                number: this.companyData.contact?.whatsapp?.e164Number.substring(1),
                // text: codec.encodeKey(`Hi, I'am interested in [ ${this.property.name.en} ] - [${this.property.code}] ${environment.web + this.router.url}`)
            };
        } else {
            this.whatsapp = null;
        }
    }

    askVendor() {
        if (!this.userDetails) {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: this.router.routerState.snapshot.url,
                },
            });
            return;
        }

        this.bsModalRef = null;

        const initialState = {
            companyId: this.companyData._id
        };

        this.bsModalRef = this.modalService.show(AskVendorComponent, { initialState });
        this.bsModalRef.content.closeBtnName = 'Close';
    }
    companyInformation(): void {
        this.bsModalRef = null;

        const initialState = {
            companyData: this.companyData
        };

        this.bsModalRef = this.modalService.show(ModalCompanyInformationComponent, {
            initialState,
            class: 'full-screen',
            ignoreBackdropClick: false
        });

        this.bsModalRef.content.closeBtnName = 'Close';
    }

    openChat(): any {
        if (!this.userDetails || !this.authService.currentUserValue) {
            return this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
        }

        // create chat
        var newChat: any = {
            "companyId": this.companyData._id,
            "subject": {
                "type": "page",
                "title": {
                    "en": this.titleService.getTitle(),
                    "ar": this.titleService.getTitle(),
                },
                "url": window.location.href,
                "ObjectId": null,
            },
            "type": 'vendor',
            "message": ""
        };

        this.chatService.createChat(newChat).subscribe((response: any) => {
            // console.log("CREATE CHAT::", response);

            this.bsModalRef = null;

            const initialState = {
                chatId: response.data?._id
            };

            this.bsModalRef = this.modalService.show(ChatModalComponent, {
                initialState,
                class: 'full-screen live-chat-popup',
                backdrop: false,
                ignoreBackdropClick: true
            });

            this.bsModalRef.content.closeBtnName = 'Close';
            
            this.renderer.addClass(document.body, 'chat-modal');
        });
    }
}
